var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('Stats'),_c('iframe',{attrs:{"src":"https://dm.itmaster.dk/view/msTF1fHvk5TgVV1PLU6lJl0scuTW74Md"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }